<script>
import { BBadge } from "bootstrap-vue";

export default {
  extends: BBadge
};
</script>